import { getPublisherSASuggestions } from 'app/sponsoredAds/services/autosuggestServices';
import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';
import withMultiSelectAutosuggest from './withMultiSelectAutosuggest';


const PublisherAutosuggestSA = autosuggestFactory({
   apiPromise: getPublisherSASuggestions,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndNameAsLabel,
   defaultPlaceholder: 'Search Publisher...',
});

export default withAutosuggestWrapper(withInputErrorMessage(PublisherAutosuggestSA));
export const PublisherMultiSelectSA = withMultiSelectAutosuggest(PublisherAutosuggestSA);
